import { AnalyticsProvider, AnalyticsEvent, AnalyticsConfig } from "./types";

export class Analytics {
  private providers: AnalyticsProvider[];

  private enabled: boolean;

  constructor(config: AnalyticsConfig) {
    this.providers = config.providers || [];
    this.enabled = config.enabled !== false;
  }

  trackEvent(eventName: string, properties?: Record<string, any>): void {
    if (!this.enabled) return;

    const event: AnalyticsEvent = {
      name: eventName,
      properties,
    };

    this.providers.forEach((provider) => {
      try {
        provider.trackEvent(event);
      } catch (error) {
        console.error(`Analytics provider error:`, error);
      }
    });
  }

  identify(userId: string, properties?: Record<string, any>): void {
    if (!this.enabled) return;

    this.providers.forEach((provider) => {
      try {
        provider.identify(userId, properties);
      } catch (error) {
        console.error(`Analytics provider error during identify:`, error);
      }
    });
  }

  reset(): void {
    if (!this.enabled) return;

    this.providers.forEach((provider) => {
      try {
        provider.reset();
      } catch (error) {
        console.error(`Analytics provider error during reset:`, error);
      }
    });
  }

  addProvider(provider: AnalyticsProvider): void {
    this.providers.push(provider);
  }

  removeProvider(provider: AnalyticsProvider): void {
    const index = this.providers.indexOf(provider);
    if (index > -1) {
      this.providers.splice(index, 1);
    }
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  isEnabled(): boolean {
    return this.enabled;
  }
}
